// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2H9.57995L11.0668 8.69061L9.2078 10.5496C10.2994 12.2508 11.7492 13.7006 13.4504 14.7922L15.3094 12.9332L22 14.4201V23H21C17.0022 23 13.2755 21.826 10.1497 19.8036C7.76894 18.2633 5.73668 16.2311 4.1964 13.8503C2.17402 10.7245 1 6.99781 1 3V2Z"}}]};

const CallFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'call-filled',
    ref,
    icon: element,
  },
));

CallFilledIcon.displayName = 'CallFilledIcon';

export default CallFilledIcon;
